import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
      {
            id: 1,
            label: 'Pre Lead',
            link: '/pre-lead',
            icon: 'UserList',
            permission: 'Lead.PreLead'
      },
      {
            id: 2,
            label: 'Vendor Management',
            link: '/vendor-management',
            icon: 'ClipboardText',
            permission: 'Lead.VendorManagement'
      },

      {
            id: 3,
            label: "Agent Wallet",
            link: "/wallet",
            icon: 'Wallet',
            permission: "Lead.AgentWallet",
      },
      {
            id: 4,
            label: "Pre Lead Filters",
            link: "/lead-filter",
            icon: 'Funnel',
            permission: "Lead.PreLeadFilters",
      },

];
